import { createApp } from "vue";

import JzClock from "./Clock.vue";
import JzStatistic from "./Statistic.vue";
import JzTranslateX from "./TranslateX.vue";
import JzInput from "./Input.vue";
import JzCountdown from "./Countdown.vue";
const app = createApp();

export default function (app) {
  app.component("jz-translate-x", JzTranslateX);
  app.component("jz-statistic", JzStatistic);
  app.component("jz-clock", JzClock);
  app.component("jz-input", JzInput);
  app.component("jz-countdown", JzCountdown);
}
